import script from "./ProductionDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./ProductionDashboardView.vue?vue&type=style&index=0&id=59dc4ba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59dc4ba0"]])

export default __exports__